export default "__VITE_ASSET__8E$NOlUU__"